export const GET_OBSERVER = 'GET_OBSERVER'; 
export const SET_OBSERVER_VOTERS = 'SET_OBSERVER_VOTERS'; 